import type { RadioGroupProps, Radioprops } from '@eleo-rh/core-ui'
import FilterRadioGroup from 'components/Filters/FilterRadioGroup'

export type FilterMultiButtonProps = {
  value: string | null | undefined
  onChange: (value: string | null) => void
  options?: { [p: number]: null | string }
  groupProps?: Omit<RadioGroupProps, 'children' | 'onChange' | 'value'>
  radioProps?: Omit<Radioprops, 'children' | 'value'>
  radioStyles?: Radioprops['styles']
}

interface BaseMultiButtonProps {
  labels: string[]
}

export default function BaseMultiButton({
  value,
  labels,
  onChange,
  options = { 0: null, 1: 'false', 2: 'true' },
  ...props
}: FilterMultiButtonProps & BaseMultiButtonProps) {
  return (
    <FilterRadioGroup
      value={value}
      onChange={onChange}
      {...props}
      options={labels.map((label, index) => ({
        label,
        value: options[index] ?? null,
      }))}
    />
  )
}
